<template>
  <div
    :class="['ui-radio', classList]"
  >
    <label
      class="ui-radio-label"
      :for="id"
    >
      <input
        v-model="computedValue"
        :value="option"
        type="radio"
        :checked="true"
        :disabled="disabled"
        :name="name"
        :id="id"
      >
      <span :class="['ui-radio-input', { error: error }]" />

      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'ui-radio',

  props: {
    value: {
      type: [String, Number],
      required: true,
    },

    option: {
      type: [String, Number],
      required: true,
    },

    name: {
      type: String,
      default: ''
    },

    label: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    },

    error: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },

      set() {
        this.$emit('input', this.option);
      }
    },

    classList() {
      return [{
        'disabled': this.disabled,
        'selected': this.computedValue === this.option,
      }]
    },

    isChecked() {
      return this.option === this.computedValue;
    },

    id() {
      return this.name + Math.random().toString(36).substr(2, 4);
    },
  },
};
</script>

<style lang="scss">
.ui-radio {
  position: relative;
  cursor: pointer;

  &:hover {
    .ui-radio-input {
      border-color: $gray_l;
    }
  }

  input[type="radio"] {
    display: none;
  }

  &-label {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 24px;
    cursor: pointer;
  }

  &-input {
    position: relative;
    display: block;
    width: 24px;
    height: 24px;
    margin-right: 12px;
    border: 2px solid $gray_lu;
    border-radius: 50%;
    transition: .2s ease border-color;
    cursor: pointer;
    background-color: #fff;

    &.error {
      border-color: $red;
    }

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #fff;
      transform: translate(-50%, -50%) scale(0);
      transition: .2s transform ease;
    }
  }

  &.selected {
    .ui-radio-input {
      background-color: $blue;
      border-color: $blue;

      &::after {
        transform: translate(-50%, -50%) scale(1);
      }

      &:hover {
        background-color: $blue_hover;
        border-color: $blue_hover;
      }
    }
  }

  &.disabled {
    .ui-radio-label,
    .ui-radio-input {
      pointer-events: none;
    }

    .ui-radio-label {
      color: $gray_l;
    }

    .ui-radio-input {
      border: 1px solid $gray_lu;
      background-color: $gray_bgr;

      &::after {
        background-color: rgba(#fff, .64);
      }
    }

    input[type="radio"]:checked + span {
      background-color: $gray_lu;
      border-color: $gray_lu;
    }
  }
}
</style>